import { Dayjs } from 'dayjs';
import { createContext, useContext, ReactNode } from 'react';

import { useCloseContextStore } from 'store/close/close-context.store';

interface CloseContextValue {
  closePeriod: Dayjs;
  entitySetId: string;
  setClosePeriod: (period: Dayjs) => void;
  setEntitySetId: (entityId: string) => void;
}

const CloseContext = createContext<CloseContextValue | null>(null);

export const CloseContextProvider = ({ children }: { children: ReactNode }) => {
  const closePeriod = useCloseContextStore((state) => state.closePeriod);
  const entitySetId = useCloseContextStore((state) => state.entitySetId);
  const setClosePeriod = useCloseContextStore((state) => state.setClosePeriod);
  const setEntitySetId = useCloseContextStore((state) => state.setEntitySetId);

  return (
    <CloseContext.Provider
      value={{
        closePeriod,
        entitySetId,
        setClosePeriod,
        setEntitySetId,
      }}
    >
      {children}
    </CloseContext.Provider>
  );
};

export const useCloseContext = (): CloseContextValue => {
  const context = useContext(CloseContext);
  if (!context) {
    throw new Error(
      'useCloseContext must be used within a CloseContextProvider'
    );
  }
  return context;
};
